import React from 'react';
import { MoreWrapper } from './styled';

const More = ({ count, onClick }) => {
  if (count <= 0) {
    return null;
  }
  return (
    <MoreWrapper onClick={onClick}>
      {count}
      {' '}
      More
    </MoreWrapper>
  );
};

export default More;
